"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
const minifiers_1 = require("./minifiers");
class MinifiedPredicate {
}
__decorate([
    (0, class_transformer_1.Expose)({ name: 't', groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.minifyType, { groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.unMinifyType, { groups: ['unMinify'] })
], MinifiedPredicate.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'n', groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.minifyNegated, { groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.unMinifyNegated, { groups: ['unMinify'] })
], MinifiedPredicate.prototype, "isNegated", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'o', groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.minifyOperator, { groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.unMinifyOperator, { groups: ['unMinify'] })
], MinifiedPredicate.prototype, "operator", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'f', groups: ['minify'] })
], MinifiedPredicate.prototype, "filterCriteria", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'fid', groups: ['minify'] })
], MinifiedPredicate.prototype, "filterCriteriaId", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'p', groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.minifyPredicateDefinition, { groups: ['minify'] }),
    (0, class_transformer_1.Transform)(minifiers_1.unMinifyPredicateDefinition, { groups: ['unMinify'] })
], MinifiedPredicate.prototype, "predicateDefinition", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'pid', groups: ['minify'] })
], MinifiedPredicate.prototype, "predicateDefinitionId", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'v', groups: ['minify'] })
], MinifiedPredicate.prototype, "parameterValue", void 0);
__decorate([
    (0, class_transformer_1.Expose)({ name: 'c', groups: ['minify'] }),
    (0, class_transformer_1.Type)(() => MinifiedPredicate)
], MinifiedPredicate.prototype, "children", void 0);
exports.default = MinifiedPredicate;
//# sourceMappingURL=MinifiedPredicate.js.map